import { Box, Typography } from "@mui/material";
import type { CustomerContext } from "../auth/auth";
import { useLoyaltyPoints } from "../loyalty/useLoyaltyPoints";

export function LoyaltyPointsInfoMobile({ context }: { context: CustomerContext | null }) {
  const isCustomer = context?.role === "CUSTOMER";
  const { loyaltyPoints } = useLoyaltyPoints(isCustomer);

  return (
    <Box sx={{ px: 2, py: 1.5, display: { xs: "block" } }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: "bold", textTransform: "uppercase", letterSpacing: 0.5, color: "text.secondary" }}
      >
        Program partnerski
      </Typography>
      <Typography variant="body1" sx={{ mt: 0.5, fontWeight: "600" }}>
        {loyaltyPoints?.points ?? 0} punktów
      </Typography>
    </Box>
  );
}
